import { Permissions } from '../interfaces/permission';
import { baseFetch } from './BaseFetch';

export const getPermissions = async () => {
  return await baseFetch<{}, Permissions>('/accesses', {}, 'GET', true);
};
